import { Col, Input } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addCardProps } from '../../actions';
import { IState } from '../../graphql/types';
import { handleInputChange } from '../utils';
import { CardFormField } from './CardFormField';
import CardFormTextArea from './CardFormTextArea';

import styles from './CardForm.module.css';

const QuoteForm: React.FC<{ saving: boolean }> = ({ saving }) => {
  const dispatch = useDispatch();
  const text = useSelector<IState, string | undefined>(
    state => state.cardProps?.text as string | undefined
  );
  const author = useSelector<IState, string | undefined>(
    state => state.cardProps?.author as string | undefined
  );
  // const affiliation = useSelector<IState, string | undefined>(
  //   state => state.cardProps?.affiliation as string | undefined
  // );

  return (
    <div className={styles.formWrapper}>
      <Col span={24}>
        <CardFormTextArea
          autoFocus
          name="quoteDescription"
          fieldLabel="Quote"
          defaultValue={text}
          rows={3}
          showCount
          maxLength={300}
          onChange={handleInputChange(value =>
            dispatch(addCardProps('text', value))
          )}
          disabled={saving}
          placeholder="I am I because my little dog knows me."
        />
      </Col>
      <Col span={24}>
        <CardFormField
          name="quoteAuthor"
          fieldLabel="Author (optional)"
          defaultValue={author}
          customValidator={e =>
            e.target.value.length <= 80
              ? e.target.value
              : e.target.value.slice(0, -1)
          }
          customRules={[
            { max: 80, message: 'Limit of 80 characters exceeded' },
          ]}
          required={false}
        >
          <Input
            className="modal-form-input"
            onChange={handleInputChange(value =>
              dispatch(addCardProps('author', value))
            )}
            disabled={saving}
            placeholder="Gertrude Stein"
          />
        </CardFormField>
      </Col>
      {/* <Col span={24}>
        <CardFormField
          name="quoteAffiliation"
          fieldLabel="Title (optional)"
          defaultValue={affiliation}
          customValidator={e =>
            e.target.value.length <= 80
              ? e.target.value
              : e.target.value.slice(0, -1)
          }
          customRules={[
            { max: 80, message: 'Limit of 80 characters exceeded' },
          ]}
          required={false}
        >
          <Input
            className="modal-form-input"
            onChange={handleInputChange(value => {
              // let validated = value;
              // if (value === '') validated = null;
              dispatch(addCardProps('affiliation', value));
            })}
          />
        </CardFormField>
      </Col> */}
    </div>
  );
};

export default QuoteForm;
